export class MoleculePanelOverviewHeaderMultiUnlockSubaccountActionComponent {
    public templateUrl = require('./multi-unlock-subaccount-action.html?external');
}
